export default __webpack_public_path__ + "static/media/energy.0788943a.mp4";